import { AppNavMenu, AppRoute } from 'src/pages';
import { TagsOutlined } from '@ant-design/icons';
import { tagSettingsRoutes } from './tags';

export const settingsRoutes: AppRoute[] = [...tagSettingsRoutes];

export const settingsNavMenus: AppNavMenu[] = [
  {
    path: '/tags',
    title: 'Tags',
    icon: <TagsOutlined />,
  },
];
